export const ProfileContainer = {
  transclude: true,

  bindings: {
    isEditing: '<',
    onClick: '&',
  },

  template: `
    <div class="container container--profile p-3 p-md-4 bg-white">
      <box-corner
        icon="pencil"
        ng-click="$ctrl.onClick()"
        ng-hide="$ctrl.isEditing">
      </box-corner>
      <ng-transclude></ng-transclude>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileContainer.js